<template>
  <div id="head" class="wrapper">
    <template v-if="isMobile">
      <!-- 移动端 -->
      <div class="mobile fff">
        <div class="headerBar flex ali_cen">
          <img class="meau" src="../assets/img/meau.png" @click="leftMeau = true">
        </div>
        <div :class="['mask meauList', leftMeau ? 'show' : '']">
          <div class="meauCont fff">
            <div class="top flex ali_cen ju_sp">
              <img class="logo" src="../assets/img/logo.png">
              <img class="close" src="../assets/img/close.png" @click="leftMeau = false">
            </div>
            <div class="list">
              <div v-for="(v, k) in configNav" :key="k" :class="['item', $route.meta.index == v.id ? 'active' : '']"  @click="changeMeau(v)">
                <div class="name">{{$route.meta.index == v.id ? v.actName : v.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="web flex ali_cen ju_sp">
        <!-- webPc导航 -->
        <div class="head flex ali_cen" @click="handelTab('/')">
          <img class="logo" src="../assets/img/logo.png" alt="logo">
        </div>
        <div class="nav flex ali_cen">
          <div v-for="item in configNav" :key="item.id" :class="{ item, active: $route.meta.index == item.id }" @click="handelTab(item)">
            <p class="nav-name">{{$route.meta.index == item.id ? item.actName : item.name}}</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import utils from "@/utils/utils";
export default {
  name: "headerBar",
  data() {
    return {
      isMobile: false,
      currentRouter: '',
      configNav: [
        { id: 0, name: "About us", actName: 'About us', path: "/index" },
        { id: 1, name: "Our team", actName: 'Our team', path: "/team" },
        { id: 2, name: "Our strategy", actName: 'Our strategy', path: "/strategy" },
        { id: 3, name: "Contact us", actName: 'Contact us', path: "/contact" }
      ],
      leftMeau: false
    };
  },
  mounted() {
    this.currentRouter = this.$route.path;
    this.isMobile = utils.isMobile();
  },
  methods: {
    handelTab(e) {
      if(e == '/' && this.currentRouter != '/index') {
        this.currentRouter = '/index';
        this.$router.push({ path: '/index' });
        return
      }
      if(e.path && e.path != this.currentRouter) {
        this.currentRouter = e.path;
        this.$router.push({ path: e.path });
      }
    },
    // 手机切换菜单
    changeMeau(e) {
      this.leftMeau = false;
      this.currentRouter = e.path;
      this.$router.push({ path: e.path });
    }
  },
};
</script>

<style scoped lang="less">
.web {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  padding: 0 240px;
  background: #fff;
  box-shadow: 0 3px 14px 0 rgba(0,0,0,0.12);

  .head {
    cursor: pointer;

    .logo {
      width: 217px;
      height: 28px;
    }
  }

  .nav {
    .item {
      margin-right: 60px;
      cursor: pointer;

      &.active {
        position: relative;
        font-weight: 600;

        &::after {
          content: "";
          width: 100%;
          height: 3px;
          background: #C52133;
          position: absolute;
          left: 0;
          bottom: 2px;
        }
      }

      .nav-name {
        font-weight: 400;
        font-size: 22px;
        color: #C52133;
        line-height: 90px;
      }
    }
  }
}

.mobile {
  width: 100%;
  height: 230px;
  padding-right: 40px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;

  .headerBar {
    height: 230px;

    .meau {
      width: 120px;
      height: 120px;
      padding: 0 60px;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 111;

    &.meauList {
      left: -100%;
      transition: left 0.8s;

      &.show {
        left: 0;
      }
    }

    .meauCont {
      width: 87%;
      height: 100vh;
      padding: 0 4%;

      .top {
        padding: 100px 0 40px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .logo {
          width: 998px;
          height: 128.8px;
        }

        .close {
          width: 150px;
          height: 150px;
        }
      }

      .list {
        padding-top: 10%;

        .item {
          height: 300px;
          padding: 0 100px;
          line-height: 300px;

          &.active {
            position: relative;
            background: rgba(197,33,51,0.08);

            .name {
              font-weight: 600;
              color: #C52133;
            }

            &::after {
              content: "";
              width: 30px;
              height: 50%;
              background: #C52133;
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
            }
          }

          .name {
            font-size: 75px;
            font-weight: 400;
            color: rgba(197,33,51,0.8);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue